import { dispatchAnalyticEvent } from '@/components/webcomponents/Global/analyticsEvents'
import type {
  CallbackEvent,
  TableRowCellDropdown,
} from '@/components/webcomponents/DataTable/types/Table.type'

export function createDropdownCell(
  cell: TableRowCellDropdown,
  componentName: string,
  element: HTMLElement,
  callback: ((e: CallbackEvent) => void) | null,
): HTMLTableCellElement {
  const td = document.createElement('td')
  td.part = 'cell'
  const dropdownCell = cell as TableRowCellDropdown
  const dd = document.createElement('wa-dropdown')
  const button = document.createElement('wa-button')
  button.slot = 'trigger'
  button.part = 'cell-dropdown-button'
  button.setAttribute('exportparts', 'base:cell-button-base')
  button.setAttribute('appearance', 'outlined')
  button.setAttribute('variant', 'neutral')
  button.setAttribute('size', 'small')
  button.setAttribute('with-caret', '')
  button.innerText = cell.text || ''
  dd.appendChild(button)

  if (dropdownCell.items) {
    for (const item of dropdownCell.items) {
      const option = document.createElement('wa-dropdown-item')
      option.textContent = item.text

      option.addEventListener('click', () => {
        // Fire analytics event for table sorting
        dispatchAnalyticEvent('ascend_table_celldropdownitem_selected', 'click', componentName, {
          label: `${option.textContent || 'unknown'}`,
        })

        const eventData = { actionType: 'click-dropdownitem' as const, key: item.key ?? '' }

        if (callback) {
          document.AscendAwesome?.LogManager?.logWarning('callback is deprecated. See docs.')
          callback(eventData)
        }

        if (element && typeof element.dispatchEvent === 'function') {
          element.dispatchEvent(
            new CustomEvent('dropdown-item-selected', {
              detail: eventData,
              bubbles: true,
              composed: true,
            }),
          )
        }
      })
      dd.appendChild(option)
    }
  }

  td.appendChild(dd)

  return td
}
